import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { defaultProfilePostsFilterSchema } from '@anytag/shared-organisms';
import { FacebookPageAnalyticsPostsSortOrder } from '@anytag/graphql';

export const AnalyticsFbFeedPostSearchSchema = SearchSchema.create({
  filter: defaultProfilePostsFilterSchema,
  sort: { field: FacebookPageAnalyticsPostsSortOrder }
});

export type AnalyticsFbFeedPostSearchSchemaType = z.infer<typeof AnalyticsFbFeedPostSearchSchema>;
